document.addEventListener('DOMContentLoaded', () => {
  function restartVideos() {
    // console.log('restart video');
    document.querySelectorAll('div[class^="media--media-section__media--"] video,  .i-stps-media video').forEach(v => {
      v.play().catch(() => {});
    });
  }

  document.addEventListener('variant:change', () => setTimeout(restartVideos, 100));

  if (window.Shopify && window.Shopify.theme) {
    document.addEventListener('change', (e) => {
      if (e.target.name === 'id' || e.target.closest('.product-form')) {
        setTimeout(restartVideos, 100);
      }
    });
  }

  const observer = new MutationObserver(() => {
    document.querySelectorAll('div[class^="media--media-section__media--"] video,  .i-stps-media video').forEach(v => {
      if (v.paused) v.play().catch(() => {});
    });
  });

  observer.observe(
    document.querySelector('product-info')?.closest('section') || document.body,
    { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] }
  );

  restartVideos();
});